import { BrickInventoryEntry } from "../../../../BrickInventory/BrickInventory";
import { SetEntry } from "../../../../SetInventory/SetInventory";
import { ActionEntry } from "../../../ActionEntries";

export const meetsCostRequirementsBrickPack = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
  newSets: Map<string, SetEntry>,
  totalAmt: number, // total packs purchased
) => {
  if (!action.isBrickpack) return false;

  // Validate if costs for action can be met (both bricks and sets)
  for (let i = 0; i < action.cost.length; i++) {
    const costEntry = action.cost[i];
    // no costScale or costIncrement for brickpacks
    const trueCost = costEntry.baseChangeValue * totalAmt; // trueCost * total packs purchased

    // Default to "brick" if type not specified (backward compatibility)
    const costType = costEntry.type || "brick";

    if (costType === "brick") {
      // Check brick costs
      const currBrick = newBricks.get(costEntry.brickId);

      if (
        !currBrick ||
        Number.isNaN(currBrick.amount) ||
        currBrick.amount < trueCost
      )
        return false;
    } else if (costType === "set") {
      // Check set costs
      const currSet = newSets.get(costEntry.brickId); // brickId field contains set ID

      if (!currSet || currSet.count < trueCost) return false;
    }
  }

  return true;
};
